module.exports = typeof function foo() {}.name === 'string'; // when function names are minified, checking for "foo" would break



//////////////////
// WEBPACK FOOTER
// ./node_modules/function.prototype.name/helpers/functionsHaveNames.js
// module id = 301
// module chunks = 0